<template>
  <div>
    <h2 class="text-lg font-semibold mb-4">Reporting</h2>
    <Alert v-if="loaded && !stores.length" type="error" class="my-2">
      Aucun point de vente n'est associé à ce challenge.
    </Alert>
    <template v-else-if="loaded">
      <div class="max-h-60 overflow-y-auto border border-gray-200 rounded-sm p-2">
        <div v-for="(store, index) in stores" :key="store.id" class="flex items-center mt-2">
          <Checkbox
            :id="`store-${index}`"
            :name="`store-${index}`"
            :checkedValue="store.id"
            :uncheckedValue="false"
            v-model="selectedStoreIds"
            :label="store.salesChannel"
            labelClass="pr-6 text-sm font-medium text-gray-900 whitespace-nowrap"
          />
        </div>
      </div>
      <div class="flex gap-2 items-center mt-2">
        <div
          class="text-center cursor-pointer inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-xs text-xs font-medium rounded-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          data-test="clear-selection"
          @click="clearSelection"
        >
          Effacer
        </div>
        <div
          class="text-center cursor-pointer px-2.5 py-1.5 border border-gray-300 shadow-xs text-xs rounded-sm text-gray-700 bg-white hover:bg-gray-50"
          data-test="select-all-stores"
          @click="selectAllStores"
        >
          Tout sélectionner
        </div>
      </div>
      <GenericButton class="mt-5" data-test="download-reporting" @click="downloadChallengeReporting">
        Télécharger
      </GenericButton>
    </template>
  </div>
</template>

<script>
import { Alert, Checkbox, GenericButton, download, toCamelCase } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    Alert,
    Checkbox,
    GenericButton,
  },
  emits: ["success"],
  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      stores: [],
      selectedStoreIds: [],
      loaded: false,
    };
  },
  mounted() {
    this.fetchChallengeStores();
  },
  methods: {
    ...mapActions("challenges", ["downloadReporting", "fetch"]),
    ...mapActions("backoffice", ["withLoader"]),

    async fetchChallengeStores() {
      await this.withLoader(async () => {
        const response = await this.fetch({
          challengeId: this.challenge.id,
          includes: ["stores"],
        });
        if (!response?.success) return;

        this.stores = toCamelCase(response.data.challenge.stores);
        this.selectedStoreIds = this.stores.map((store) => store.id);
      });
      this.loaded = true;
    },

    selectAllStores() {
      this.selectedStoreIds = this.stores.map((store) => store.id);
    },

    clearSelection() {
      this.selectedStoreIds = [];
    },

    async downloadChallengeReporting() {
      const response = await this.downloadReporting({
        challengeId: this.challenge.id,
        storeIds: this.selectedStoreIds,
      });
      download(response.data.csv_data, response.data.filename);
    },
  },
};
</script>
